<svg class="building-site" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 383.2 193.4" xml:space="preserve">
	<g>
		<g>
			<g>
				<path
					class="building-site-0"
					d="M58.7,102.7c-0.1,0-0.2,0.1-0.3,0.1c-2.7,1.3-4.2,1.1-6.8-0.1c-2.5-1.1-4.8-2.5-6.9-4.3
                    c-2.6-2.3-4.6-5.3-5-8.7c-0.1-0.8-0.1-1.6,0.4-2.2c0.6-0.9,1.9-1,2.9-0.6s1.8,1.1,2.5,1.9c0.3,0.3,0.7,0.6,1.1,0.7
                    c0.4,0.1,1,0,1.2-0.4c0.4-0.6-0.3-1.3-0.8-1.8c-1.3-1.1-2.5-1.7-3.8-2.6c-1.7-1.2-3.2-2.6-4.2-4.5c-0.9-1.8-1.1-4.1-0.2-5.9
                    c0.3-0.6,0.7-1.1,1.2-1.4c0.9-0.6,2.1-0.6,3.2-0.3c1.1,0.2,2.1,0.6,3.2,0.8c2.6,0.3,3.6-1.6,3.6-4c0-1.6-0.6-3.2-0.6-4.8
                    c-0.2-2.8,1.2-5.8,3.8-7.1c2.6-1.2,6.1-0.1,7.1,2.6c1,2.9-1.3,6.2,0.2,9c0.5,0.9,1.6,2.2,2.5,2.7c1.4,0.9,3.5-0.2,5.2-0.1
                    c0.4,0,0.8,0.1,1,0.3s0.3,0.5,0.3,0.7c0.4,2-0.3,4.2-1.9,5.6c-1.7,1.6-4.7,2.4-5.4,4.8c-0.5,1.5-0.3,5.3,2.2,4.9
                    c0.9-0.1,1.5-1,2.4-1.3c1.1-0.4,2.3,0.4,2.8,1.4s0.3,2.3-0.1,3.3c-0.7,1.7-1.9,3-3.2,4.3C63.8,98.5,62.1,101.1,58.7,102.7z"
				/>
			</g>
			<line class="building-site-1" x1="55.1" y1="67.3" x2="55.1" y2="141.5" />
			<polyline class="building-site-1" points="62,77.5 55.1,84.4 48.2,77.5" />
			<polyline class="building-site-1" points="62,91.4 55.1,98.2 48.2,91.4" />
		</g>
		<g>
			<g>
				<path
					class="building-site-0"
					d="M369.3,145.3c-0.1,0.1-0.2,0.1-0.3,0.2c-3.4,1.6-5.1,1.3-8.4-0.2c-3-1.4-5.9-3-8.4-5.2
                    c-3.2-2.8-5.6-6.6-6.1-10.8c-0.1-0.9-0.1-2,0.4-2.7c0.8-1,2.3-1.2,3.5-0.7s2.2,1.4,3.1,2.3c0.4,0.4,0.8,0.7,1.4,0.9
                    c0.5,0.1,1.2,0,1.5-0.5c0.4-0.8-0.3-1.7-1-2.2c-1.6-1.3-3-2.1-4.7-3.2c-2.1-1.5-4-3.2-5.1-5.5s-1.4-5.1-0.2-7.3
                    c0.4-0.7,0.9-1.3,1.5-1.7c1.2-0.7,2.6-0.7,4-0.4c1.3,0.3,2.6,0.8,4,0.9c3.2,0.3,4.5-1.9,4.4-4.9c0-2-0.7-3.9-0.8-5.9
                    c-0.2-3.5,1.5-7.2,4.7-8.7c3.1-1.5,7.5-0.1,8.7,3.2c1.2,3.6-1.6,7.6,0.3,11c0.6,1.1,2,2.7,3,3.3c1.8,1.1,4.3-0.2,6.3-0.1
                    c0.5,0,0.9,0.1,1.3,0.4c0.2,0.2,0.3,0.6,0.4,0.9c0.5,2.5-0.4,5.2-2.3,6.9c-2.1,1.9-5.8,2.9-6.7,5.9c-0.6,1.9-0.3,6.6,2.7,6.1
                    c1.1-0.2,1.9-1.3,2.9-1.6c1.3-0.4,2.9,0.4,3.4,1.7c0.6,1.3,0.4,2.8-0.1,4.1c-0.8,2.1-2.4,3.7-3.9,5.3
                    C375.6,140.1,373.5,143.3,369.3,145.3z"
				/>
			</g>
			<line class="building-site-1" x1="364.9" y1="101.7" x2="364.9" y2="193" />
			<polyline class="building-site-1" points="373.3,114.4 364.9,122.8 356.4,114.4" />
			<polyline class="building-site-1" points="373.3,131.3 364.9,139.8 356.4,131.3" />
		</g>
	</g>
	<g>
		<g id="buildingSite_79_">
			<path id="buildingSite_802_" class="building-site-2 fill-primary" d="M124.1,183.5H6.8V111c0-0.7,0.6-1.3,1.3-1.3h114.8c0.7,0,1.3,0.6,1.3,1.3v72.5H124.1z" />
			<rect id="buildingSite_799_" x="12.8" y="116.4" class="building-site-3" width="105.3" height="61.1" />
			<path
				id="buildingSite_76_"
				class="building-site-4"
				d="M131,186.8H0l0,0c3.7,3.7,8.8,5.8,14.1,5.8H117C122.2,192.6,127.2,190.5,131,186.8L131,186.8z
                "
			/>
			<rect id="buildingSite_75_" y="183.1" class="building-site-5" width="131" height="3.7" />
			<path
				id="buildingSite_77_"
				class="building-site-4"
				d="M73.6,186H57.4c-0.6,0-1-0.5-1-1l0,0c0-0.6,0.5-1,1-1h16.2c0.6,0,1,0.5,1,1l0,0
                C74.6,185.5,74.1,186,73.6,186z"
			/>
			<path
				id="buildingSite_80_"
				class="building-site-6"
				d="M35.8,134.9H23.2c-1.2,0-2.1-1-2.1-2.1l0,0c0-1.2,1-2.1,2.1-2.1h12.7c1.2,0,2.1,1,2.1,2.1l0,0
                C38,134,37,134.9,35.8,134.9z"
			/>
			<path
				id="buildingSite_84_"
				class="building-site-7"
				d="M61.4,146.5H42.8c-1.2,0-2.1-1-2.1-2.1l0,0c0-1.2,1-2.1,2.1-2.1h18.6c1.2,0,2.1,1,2.1,2.1l0,0
                C63.5,145.6,62.5,146.5,61.4,146.5z"
			/>
			<path
				id="buildingSite_87_"
				class="building-site-6"
				d="M75.9,146.5h-7.2c-1.2,0-2.1-1-2.1-2.1l0,0c0-1.2,1-2.1,2.1-2.1h7.2c1.2,0,2.1,1,2.1,2.1l0,0
                C78.1,145.6,77.1,146.5,75.9,146.5z"
			/>
			<path
				id="buildingSite_85_"
				class="building-site-7"
				d="M61.4,158.1h-30c-1.2,0-2.1-1-2.1-2.1l0,0c0-1.2,1-2.1,2.1-2.1h30c1.2,0,2.1,1,2.1,2.1l0,0
                C63.5,157.2,62.5,158.1,61.4,158.1z"
			/>
			<path
				id="buildingSite_88_"
				class="building-site-7"
				d="M69.5,158.1h40c1.2,0,2.1-1,2.1-2.1l0,0c0-1.2-1-2.1-2.1-2.1h-40c-1.2,0-2.1,1-2.1,2.1l0,0
                C67.4,157.2,68.3,158.1,69.5,158.1z"
			/>
			<path
				id="buildingSite_86_"
				class="building-site-7"
				d="M40.1,169.8h-17c-1.2,0-2.1-1-2.1-2.1l0,0c0-1.2,1-2.1,2.1-2.1h17c1.2,0,2.1,1,2.1,2.1l0,0
                C42.3,168.8,41.3,169.8,40.1,169.8z"
			/>
			<path
				id="buildingSite_89_"
				class="building-site-8"
				d="M47.3,169.8h5.5c1.2,0,2.1-1,2.1-2.1l0,0c0-1.2-1-2.1-2.1-2.1h-5.5c-1.2,0-2.1,1-2.1,2.1l0,0
                C45.2,168.8,46.1,169.8,47.3,169.8z"
			/>
			<path
				id="buildingSite_90_"
				class="building-site-7"
				d="M59.9,169.8h41.3c1.2,0,2.1-1,2.1-2.1l0,0c0-1.2-1-2.1-2.1-2.1H59.9c-1.2,0-2.1,1-2.1,2.1l0,0
                C57.8,168.8,58.8,169.8,59.9,169.8z"
			/>
			<path
				id="buildingSite_83_"
				class="building-site-7"
				d="M75.9,134.9H44.4c-1.2,0-2.1-1-2.1-2.1l0,0c0-1.2,1-2.1,2.1-2.1h31.5c1.2,0,2.1,1,2.1,2.1l0,0
                C78.1,134,77.1,134.9,75.9,134.9z"
			/>
			<path
				id="buildingSite_91_"
				class="building-site-7"
				d="M83.1,134.9h11.1c1.2,0,2.1-1,2.1-2.1l0,0c0-1.2-1-2.1-2.1-2.1H83.1c-1.2,0-2.1,1-2.1,2.1l0,0
                C81,134,81.9,134.9,83.1,134.9z"
			/>
		</g>
	</g>
	<g>
		<g>
			<path class="building-site-6" d="M289.8,193.4h-185V5.1c0-2.8,2.3-5.1,5.1-5.1h174.7c2.8,0,5.1,2.3,5.1,5.1v188.3L289.8,193.4L289.8,193.4z" />
			<rect x="111.6" y="30.2" class="building-site-9" width="172.2" height="163.2" />
			<rect x="126.9" y="42.2" class="building-site-10" width="141.5" height="54.4" />
			<rect x="168.3" y="42.2" class="building-site-2 fill-primary" width="100.2" height="54.4" />
			<rect x="126.9" y="42.2" class="building-site-2 fill-primary" width="141.6" height="23.3" />
			<path
				class="building-site-2 fill-primary"
				d="M160.7,81.1L160.7,81.1c-1.5,0-2.7-1.2-2.7-2.7V60.5c0-1.5,1.2-2.7,2.7-2.7l0,0c1.5,0,2.7,1.2,2.7,2.7v17.9
                C163.4,79.9,162.2,81.1,160.7,81.1z"
			/>
			<path
				class="building-site-2 fill-primary"
				d="M150.2,74.2L150.2,74.2c-1.5,0-2.7-1.2-2.7-2.7V60.7c0-1.5,1.2-2.7,2.7-2.7l0,0c1.5,0,2.7,1.2,2.7,2.7v10.8
                C152.9,73,151.7,74.2,150.2,74.2z"
			/>
			<path
				class="building-site-2 fill-primary"
				d="M155.5,54.7c-1.5,0-2.7,1.2-2.7,2.7v10.8c0,0.1,0,0.1,0,0.2c0.1-1.4,1.2-2.5,2.6-2.5c1.4,0,2.5,1.1,2.6,2.5
                c0-0.1,0-0.1,0-0.2V57.4C158.1,55.9,156.9,54.7,155.5,54.7z"
			/>
			<path
				class="building-site-2 fill-primary"
				d="M165.9,56.4c-1.5,0-2.7,1.2-2.7,2.7v10.8c0,0.1,0,0.1,0,0.2c0.1-1.4,1.2-2.5,2.6-2.5s2.5,1.1,2.6,2.5
                c0-0.1,0-0.1,0-0.2V59C168.5,57.6,167.4,56.4,165.9,56.4z"
			/>
			<rect x="154.9" y="12.8" class="building-site-3" width="92.3" height="7.6" />
			<g>
				<path
					class="building-site-2 fill-primary"
					d="M276.3,14h-7c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h7c0.5,0,0.9,0.4,0.9,0.9l0,0
                    C277.2,13.6,276.8,14,276.3,14z"
				/>
				<path
					class="building-site-2 fill-primary"
					d="M276.3,17.5h-7c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h7c0.5,0,0.9,0.4,0.9,0.9l0,0
                    C277.2,17.1,276.8,17.5,276.3,17.5z"
				/>
				<path
					class="building-site-2 fill-primary"
					d="M276.3,20.9h-7c-0.5,0-0.9-0.4-0.9-0.9l0,0c0-0.5,0.4-0.9,0.9-0.9h7c0.5,0,0.9,0.4,0.9,0.9l0,0
                    C277.2,20.5,276.8,20.9,276.3,20.9z"
				/>
			</g>
			<circle class="building-site-11" cx="122.8" cy="16.6" r="3.7" />
			<circle class="building-site-12" cx="133.7" cy="16.6" r="3.7" />
			<circle class="building-site-0" cx="144.6" cy="16.6" r="3.7" />
			<rect x="126.9" y="112.9" class="building-site-8" width="141.5" height="6.7" />
			<rect x="126.9" y="128.7" class="building-site-8" width="141.5" height="6.7" />
			<rect x="126.9" y="144.4" class="building-site-8" width="141.5" height="6.7" />
			<rect x="126.9" y="160.2" class="building-site-8" width="141.5" height="6.7" />
		</g>
	</g>
	<g>
		<g>
			<line class="building-site-1" x1="93.7" y1="49.1" x2="93.7" y2="193" />
			<line class="building-site-1" x1="116.3" y1="49.1" x2="116.3" y2="193" />
			<line class="building-site-1" x1="93.7" y1="70.2" x2="116.3" y2="70.2" />
			<line class="building-site-1" x1="93.7" y1="60.4" x2="116.3" y2="60.4" />
			<line class="building-site-1" x1="93.7" y1="79.9" x2="116.3" y2="79.9" />
			<line class="building-site-1" x1="93.7" y1="89.6" x2="116.3" y2="89.6" />
			<line class="building-site-1" x1="93.7" y1="99.3" x2="116.3" y2="99.3" />
			<line class="building-site-1" x1="93.7" y1="109" x2="116.3" y2="109" />
			<line class="building-site-1" x1="93.7" y1="118.8" x2="116.3" y2="118.8" />
			<line class="building-site-1" x1="93.7" y1="128.5" x2="116.3" y2="128.5" />
			<line class="building-site-1" x1="93.7" y1="138.2" x2="116.3" y2="138.2" />
			<line class="building-site-1" x1="93.7" y1="147.9" x2="116.3" y2="147.9" />
			<line class="building-site-1" x1="93.7" y1="157.7" x2="116.3" y2="157.7" />
			<line class="building-site-1" x1="93.7" y1="167.4" x2="116.3" y2="167.4" />
			<line class="building-site-1" x1="93.7" y1="177.1" x2="116.3" y2="177.1" />
			<line class="building-site-1" x1="93.7" y1="186.8" x2="116.3" y2="186.8" />
		</g>
	</g>
	<g>
		<g id="buildingSite_334_">
			<g id="buildingSite_404_">
				<path
					id="buildingSite_408_"
					class="building-site-13"
					d="M55.9,166.3L55.9,166.3h2l2.8-8.4c0.2-0.5,0.1-1-0.1-1.5l-3.7-6.5h-0.8l-0.1,7
                    c0.1,0.1,0.7,0.3,0.8,0.4c0.5,0.5,0.5,1.4,0,1.9s-1.4,0.5-1.9,0s-0.5-1.4,0-1.9c0.1-0.1,0.5-0.4,0.6-0.4l0.2-6.9h-0.6l-3.8,6.5
                    c-0.3,0.5-0.3,1-0.2,1.5l2.7,8.4L55.9,166.3z"
				/>
				<polygon id="buildingSite_407_" class="building-site-14" points="53.9,166.3 55.9,166.3 55.9,166.3 57.9,166.3 58.8,163.5 53,163.5" />
				<rect id="buildingSite_406_" x="51.5" y="164.8" class="building-site-15" width="8.8" height="15.9" />
				<rect id="buildingSite_405_" x="55.9" y="164.8" class="building-site-16" width="4.4" height="15.9" />
			</g>
			<g id="buildingSite_392_">
				<path
					id="buildingSite_401_"
					class="building-site-17"
					d="M72,160.6v3.8c0,0.7,0.6,1.3,1.3,1.3c1.4,0,2.5,1.1,2.5,2.5v10.3c0,1.3,1.1,2.4,2.5,2.3
                    c1.2-0.1,2-1.2,2-2.4v-10.1c0-1.4,1.1-2.5,2.5-2.5c0.7,0,1.3-0.6,1.3-1.3v-3.9L72,160.6L72,160.6z M77.2,178.3
                    c0-0.4,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8S77.2,178.7,77.2,178.3z"
				/>
				<rect id="buildingSite_400_" x="72" y="148.9" class="building-site-13" width="12" height="8.7" />
				<rect id="buildingSite_399_" x="72" y="148.9" class="building-site-13" width="4.8" height="8.7" />
				<rect id="buildingSite_398_" x="72" y="157.1" class="building-site-18" width="12" height="3.5" />
				<rect id="buildingSite_397_" x="72" y="157.3" class="building-site-19" width="12" height="0.5" />
				<rect id="buildingSite_396_" x="72" y="158.6" class="building-site-19" width="12" height="0.5" />
				<rect id="buildingSite_395_" x="72" y="159.8" class="building-site-19" width="12" height="0.5" />
				<path
					id="buildingSite_394_"
					class="building-site-20"
					d="M78,160.6v16.9c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8v1.6c-1.3,0-2.3-1-2.3-2.3v-10.3
                    c0-1.4-1.1-2.5-2.5-2.5c-0.7,0-1.3-0.6-1.3-1.3v-3.7H78z"
				/>
				<path
					id="buildingSite_393_"
					class="building-site-2 fill-primary"
					d="M76.1,148.9v3.4c0,0.5,0.4,1,1,1l0,0c0.5,0,1-0.4,1-1v-1c0-0.4,0.4-0.8,0.8-0.8l0,0
                    c0.4,0,0.8,0.4,0.8,0.8v3.6c0,0.4,0.4,0.8,0.8,0.8l0,0c0.4,0,0.8-0.4,0.8-0.8v-1.7l0,0c0.9,0,1.6-0.7,1.6-1.6v-2.8h-6.8
                    C76.1,148.8,76.1,148.9,76.1,148.9z"
				/>
			</g>
			<path
				id="buildingSite_391_"
				class="building-site-21"
				d="M72,148.9v8.1v0.2v0.3v0.2v0.7v0.5v0.7v0.5v0.3v3.8c0,0.7,0.6,1.3,1.3,1.3
                c0.1,0,0.3,0,0.4,0v-12.9l-1.4-3.6L72,148.9L72,148.9z"
			/>
			<g id="buildingSite_384_">
				<rect id="buildingSite_390_" x="67.6" y="152.6" class="building-site-13" width="4.9" height="24.4" />
				<path
					id="buildingSite_389_"
					class="building-site-13"
					d="M72.6,178.2h-4.9v1.4c0,0.6,0.5,1.2,1.2,1.2h2.6c0.6,0,1.2-0.5,1.2-1.2L72.6,178.2
                    L72.6,178.2z"
				/>
				<rect id="buildingSite_388_" x="67.6" y="177" class="building-site-22" width="4.9" height="1.2" />
				<rect id="buildingSite_387_" x="67.6" y="152.6" class="building-site-23" width="2.5" height="24.4" />
				<path id="buildingSite_386_" class="building-site-24" d="M69.9,146.9l-2.3,5.7h4.9l-2.3-5.7C70.2,146.7,70,146.7,69.9,146.9z" />
				<path id="buildingSite_385_" class="building-site-22" d="M70,146.5l-0.6,1.5h1.3l-0.6-1.5C70.1,146.5,70.1,146.5,70,146.5z" />
			</g>
			<path
				id="buildingSite_383_"
				class="building-site-21"
				d="M58.4,164.8l2.3-6.8c0.2-0.5,0.1-1-0.1-1.5l-3.2-5.7l0,0v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4
                v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v1.2v0.4v0.8
                c0,0.6,0.5,1.1,1.1,1.1h1.9v-15.9h-2C58.4,165.6,58.4,164.8,58.4,164.8z"
			/>
			<g id="buildingSite_359_">
				<path
					id="buildingSite_382_"
					class="building-site-2 fill-primary"
					d="M59.4,145.8h3.9c0.6,0,1,0.5,1,1v32.9c0,0.6-0.5,1-1,1h-3.9c-0.6,0-1-0.5-1-1v-32.9
                    C58.4,146.3,58.8,145.8,59.4,145.8z"
				/>
				<path
					id="buildingSite_381_"
					class="building-site-6"
					d="M59.5,145.8h2.1v34.9h-2.1c-0.6,0-1.1-0.5-1.1-1.1v-32.7C58.4,146.3,58.9,145.8,59.5,145.8z
                    "
				/>
				<rect id="buildingSite_380_" x="58.4" y="178.3" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_379_" x="58.4" y="176.8" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_378_" x="58.4" y="175.2" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_377_" x="58.4" y="173.7" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_376_" x="58.3" y="172.1" class="building-site-25" width="1.5" height="0.4" />
				<rect id="buildingSite_375_" x="58.4" y="170.6" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_374_" x="58.4" y="169" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_373_" x="58.4" y="167.5" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_372_" x="58.4" y="165.9" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_371_" x="58.3" y="164.4" class="building-site-25" width="1.5" height="0.4" />
				<rect id="buildingSite_370_" x="58.4" y="162.8" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_369_" x="58.4" y="161.3" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_368_" x="58.4" y="159.7" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_367_" x="58.4" y="158.2" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_366_" x="58.3" y="156.6" class="building-site-25" width="1.5" height="0.4" />
				<rect id="buildingSite_365_" x="58.4" y="155.1" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_364_" x="58.4" y="153.5" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_363_" x="58.4" y="152" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_362_" x="58.4" y="150.4" class="building-site-25" width="0.7" height="0.4" />
				<rect id="buildingSite_361_" x="58.3" y="148.9" class="building-site-25" width="1.5" height="0.4" />
				<rect id="buildingSite_360_" x="58.4" y="147.3" class="building-site-25" width="0.7" height="0.4" />
			</g>
			<path
				id="buildingSite_358_"
				class="building-site-21"
				d="M63.3,145.8v6.9l0,0h-0.6v2.7v0.3v4.6h0.6v20.4c0.6,0,1-0.5,1-1.1v-32.7
                C64.3,146.3,63.9,145.9,63.3,145.8z"
			/>
			<g id="buildingSite_349_">
				<rect id="buildingSite_357_" x="64.4" y="160" class="building-site-26" width="2.6" height="20.7" />
				<rect id="buildingSite_356_" x="65.7" y="160" class="building-site-27" width="1.3" height="20.7" />
				<rect id="buildingSite_355_" x="63.8" y="155.4" class="building-site-26" width="3.5" height="4.9" />
				<rect id="buildingSite_354_" x="63.8" y="155.4" class="building-site-3" width="3.5" height="0.3" />
				<rect id="buildingSite_353_" x="63.8" y="152.7" class="building-site-26" width="3.5" height="2.7" />
				<polygon id="buildingSite_352_" class="building-site-18" points="67.2,147.1 64.4,144.7 64.4,152.7 67.2,152.7 			" />
				<polygon id="buildingSite_351_" class="building-site-5" points="64.4,145.6 64.4,152.7 67.2,152.7 67.2,148 			" />
				<polygon id="buildingSite_350_" class="building-site-28" points="65.8,152.7 67.2,152.7 67.2,148 65.8,146.8 			" />
			</g>
			<g id="buildingSite_342_" class="building-site-29">
				<path
					id="buildingSite_348_"
					class="building-site-21"
					d="M58.4,180.7h1.1h0.8h1.3h1.6h0.1l0,0c0.3,0,0.5-0.1,0.7-0.3c0,0,0,0,0-0.1
                    c0.1-0.1,0.1-0.2,0.2-0.3s0.1-0.3,0.1-0.4v-9.1H51.5v10.2h4.4L58.4,180.7L58.4,180.7z"
				/>
				<path
					id="buildingSite_347_"
					class="building-site-21"
					d="M67.6,179.4c0,0.7,0.6,1.3,1.3,1.3h2.4c0.7,0,1.3-0.6,1.3-1.3v-1.3v-1.2v-6.5h-4.9v6.5v1.2
                    v1.3H67.6z"
				/>
				<polygon id="buildingSite_346_" class="building-site-21" points="67,180.7 67,170.5 64.4,170.5 64.4,180.7 65.7,180.7 			" />
				<path
					id="buildingSite_343_"
					class="building-site-21"
					d="M75.7,170.5v8c0,0.2,0,0.3,0.1,0.5c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.2,0.1,0.2
                    c0,0.1,0.1,0.2,0.1,0.2l0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0.1,0.1s0.2,0.2,0.3,0.2l0,0c0.4,0.3,0.9,0.4,1.5,0.4
                    c1.2-0.1,2-1.2,2-2.4v-7.8H75.7z M78,179.1c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8S78.5,179.1,78,179.1z"
				/>
			</g>
			<g id="buildingSite_335_">
				<path id="buildingSite_341_" class="building-site-13" d="M85.2,193H51v-21.4h36.3v19.3C87.3,192,86.4,193,85.2,193z" />
				<path id="buildingSite_340_" class="building-site-30" d="M49.4,193H51v-21.4h-3.7v19.3C47.3,192,48.2,193,49.4,193z" />
				<polygon id="buildingSite_339_" class="building-site-14" points="47.3,176.1 49.7,176.1 51,171.6 47.3,172.5 			" />
				<path
					id="buildingSite_338_"
					class="building-site-13"
					d="M46.7,174.3h2.6c0.2,0,0.4-0.1,0.4-0.3l1.2-2.4h-3.7l-1,2
                    C46.1,173.9,46.4,174.3,46.7,174.3z"
				/>
				<polygon id="buildingSite_337_" class="building-site-14" points="87.3,176.1 87.3,172.5 51,171.6 53,176.1 			" />
				<path
					id="buildingSite_336_"
					class="building-site-13"
					d="M88.3,174.3H53.2c-0.2,0-0.3-0.1-0.4-0.2l-1.8-2.5h36.3l1.4,1.9
                    C89,173.8,88.8,174.3,88.3,174.3z"
				/>
			</g>
		</g>
		<path
			class="building-site-31"
			d="M330.2,116.2H238c-1.2,0-2.1,1-2.1,2.2v2.2v5.2v67.6h93.7h2.7v-67.6v-5.2v-1.8v-0.3
            C332.3,117.2,331.4,116.2,330.2,116.2z"
		/>
		<g>
			<path id="buildingSite_333_" class="building-site-32" d="M339.4,193.4H239.1v-72.7c0-2.4,2-4.4,4.4-4.4h91.4c2.4,0,4.4,2,4.4,4.4v72.7H339.4z" />
			<path id="buildingSite_332_" class="building-site-2 fill-primary" d="M339.4,125.6v-7.4c0-1.2-1-2.2-2.2-2.2h-95.8c-1.2,0-2.2,1-2.2,2.2v7.4H339.4z" />
			<path
				id="buildingSite_331_"
				class="building-site-3"
				d="M246.6,121.1c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3
                C246.1,119.8,246.6,120.4,246.6,121.1z"
			/>
			<path
				id="buildingSite_330_"
				class="building-site-3"
				d="M250.9,121.1c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3
                C250.3,119.8,250.9,120.4,250.9,121.1z"
			/>
			<path
				id="buildingSite_329_"
				class="building-site-3"
				d="M255.2,121.1c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3
                S255.2,120.4,255.2,121.1z"
			/>
			<path
				id="buildingSite_328_"
				class="building-site-33"
				d="M337.2,116.3h-2.8c1.2,0,2.2,1,2.2,2.2v74.9h2.8v-74.9C339.4,117.3,338.4,116.3,337.2,116.3
                z"
			/>
			<path
				class="building-site-8"
				d="M249.1,135.2h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,134.4,250.1,135.2,249.1,135.2z"
			/>
			<path
				class="building-site-8"
				d="M249.1,144.3h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,143.5,250.1,144.3,249.1,144.3z"
			/>
			<path
				class="building-site-8"
				d="M249.1,153.3h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,152.5,250.1,153.3,249.1,153.3z"
			/>
			<path
				class="building-site-8"
				d="M249.1,162.3h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,161.5,250.1,162.3,249.1,162.3z"
			/>
			<path
				class="building-site-8"
				d="M249.1,171.4h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,170.6,250.1,171.4,249.1,171.4z"
			/>
			<path
				class="building-site-8"
				d="M249.1,180.4h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,179.6,250.1,180.4,249.1,180.4z"
			/>
			<path
				class="building-site-8"
				d="M249.1,189.5h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C250.9,188.7,250.1,189.5,249.1,189.5z"
			/>
			<path
				class="building-site-8"
				d="M327.4,135.2h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,134.4,328.4,135.2,327.4,135.2z"
			/>
			<path
				class="building-site-20"
				d="M327.4,144.3h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,143.5,328.4,144.3,327.4,144.3z"
			/>
			<path
				class="building-site-34"
				d="M327.4,153.3h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,152.5,328.4,153.3,327.4,153.3z"
			/>
			<path
				class="building-site-20"
				d="M327.4,162.3h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,161.5,328.4,162.3,327.4,162.3z"
			/>
			<path
				class="building-site-34"
				d="M327.4,171.4h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,170.6,328.4,171.4,327.4,171.4z"
			/>
			<path
				class="building-site-20"
				d="M327.4,180.4h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,179.6,328.4,180.4,327.4,180.4z"
			/>
			<path
				class="building-site-8"
				d="M327.4,189.5h-1.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h1.6c1,0,1.8,0.8,1.8,1.8l0,0
                C329.2,188.7,328.4,189.5,327.4,189.5z"
			/>
			<path
				class="building-site-8"
				d="M278.9,135.2h-23.1c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h23.1c1,0,1.8,0.8,1.8,1.8l0,0
                C280.7,134.4,279.9,135.2,278.9,135.2z"
			/>
			<path
				class="building-site-13"
				d="M284.6,135.2h4.7c1,0,1.8-0.8,1.8-1.8l0,0c0-1-0.8-1.8-1.8-1.8h-4.7c-1,0-1.8,0.8-1.8,1.8l0,0
                C282.8,134.4,283.6,135.2,284.6,135.2z"
			/>
			<path
				class="building-site-13"
				d="M266.3,144.3h-10.4c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h10.4c1,0,1.8,0.8,1.8,1.8l0,0
                C268.1,143.5,267.3,144.3,266.3,144.3z"
			/>
			<path
				class="building-site-2 fill-primary"
				d="M275.6,144.3h31.2c1,0,1.8-0.8,1.8-1.8l0,0c0-1-0.8-1.8-1.8-1.8h-31.2c-1,0-1.8,0.8-1.8,1.8l0,0
                C273.8,143.5,274.6,144.3,275.6,144.3z"
			/>
			<path
				class="building-site-8"
				d="M299.8,153.3h-43.9c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h43.9c1,0,1.8,0.8,1.8,1.8l0,0
                C301.6,152.5,300.8,153.3,299.8,153.3z"
			/>
			<path
				class="building-site-8"
				d="M309.5,162.3h-53.6c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h53.6c1,0,1.8,0.8,1.8,1.8l0,0
                C311.3,161.5,310.5,162.3,309.5,162.3z"
			/>
			<path
				class="building-site-2 fill-primary"
				d="M299.8,171.4h-16.2c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h16.2c1,0,1.8,0.8,1.8,1.8l0,0
                C301.6,170.6,300.8,171.4,299.8,171.4z"
			/>
			<path
				class="building-site-8"
				d="M277,171.4h-21.1c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8H277c1,0,1.8,0.8,1.8,1.8l0,0
                C278.8,170.6,278,171.4,277,171.4z"
			/>
			<path
				class="building-site-8"
				d="M289.3,180.4h-33.4c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h33.4c1,0,1.8,0.8,1.8,1.8l0,0
                C291.1,179.6,290.3,180.4,289.3,180.4z"
			/>
			<path
				class="building-site-13"
				d="M295.3,180.4H306c1,0,1.8-0.8,1.8-1.8l0,0c0-1-0.8-1.8-1.8-1.8h-10.7c-1,0-1.8,0.8-1.8,1.8l0,0
                C293.5,179.6,294.3,180.4,295.3,180.4z"
			/>
			<path
				class="building-site-8"
				d="M299.8,189.5h-43.9c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h43.9c1,0,1.8,0.8,1.8,1.8l0,0
                C301.6,188.7,300.8,189.5,299.8,189.5z"
			/>
		</g>
		<g id="buildingSite_320_">
			<polygon id="buildingSite_327_" class="building-site-13" points="270.2,181.1 263.8,180.6 268.9,174.7 		" />
			<polygon id="buildingSite_326_" class="building-site-13" points="265.1,186.9 258.7,186.4 263.8,180.6 		" />
			<polygon id="buildingSite_325_" class="building-site-13" points="277.6,192.7 259.9,192.7 275.3,175.2 		" />
			<polygon id="buildingSite_324_" class="building-site-23" points="277.6,192.7 265.1,186.9 270.2,181 		" />
			<polygon id="buildingSite_323_" class="building-site-23" points="258.7,186.4 259.9,192.7 265,186.9 		" />
			<polygon id="buildingSite_322_" class="building-site-23" points="263.8,180.6 265.1,186.9 270.2,181.1 		" />
			<polygon id="buildingSite_321_" class="building-site-23" points="268.9,174.7 270.2,181 275.3,175.2 		" />
		</g>
		<g id="buildingSite_121_">
			<g id="buildingSite_307_">
				<path
					id="buildingSite_319_"
					class="building-site-34"
					d="M249.3,191.3c-3.7,3.1-9.2,2.6-12.2-1.1c-3.1-3.7-2.6-9.2,1.1-12.2
                    c3.7-3.1,9.2-2.6,12.2,1.1C253.5,182.8,253,188.3,249.3,191.3z"
				/>
				<g>
					<path
						class="building-site-3"
						d="M246.1,183l-2.8,5.9c0,0.1-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0s-0.2-0.1-0.2-0.3l1-4.1l-2.1,0.5c0,0,0,0-0.1,0
                        s-0.1,0-0.2-0.1s-0.1-0.1-0.1-0.2l1-4.2c0-0.1,0.1-0.2,0.2-0.2h1.7c0.1,0,0.2,0.1,0.2,0.2v0.1l-0.9,2.4l2-0.5c0,0,0,0,0.1,0
                        s0.1,0,0.2,0.1C246.1,182.8,246.1,182.9,246.1,183z"
					/>
				</g>
			</g>
			<path
				id="buildingSite_306_"
				class="building-site-35"
				d="M242.6,184.9c0-2.9-1.3-5.4-3.3-7.2c-0.4,0.2-0.8,0.5-1.2,0.8c-2,1.7-3,4-3.1,6.4
                c0.1,1.9,0.7,3.7,2,5.3c0.6,0.8,1.4,1.4,2.2,1.9C241.3,190.4,242.6,187.8,242.6,184.9z"
			/>
			<g id="buildingSite_150_">
				<path
					id="buildingSite_305_"
					class="building-site-2 fill-primary"
					d="M241.1,183.8c0,5.3-4.3,9.5-9.5,9.5c-5.3,0-9.5-4.3-9.5-9.5c0-5.3,4.3-9.5,9.5-9.5
                    S241.1,178.6,241.1,183.8z"
				/>
				<g>
					<path
						class="building-site-3"
						d="M234.1,187.1c0,0.1,0,0.2-0.1,0.2c0,0-0.5,0.2-1.1,0.2c-1.6,0-3-1-3.4-2.5H229c-0.1,0-0.2-0.1-0.2-0.2v-0.6
                        c0-0.1,0.1-0.2,0.2-0.2h0.3c0-0.2,0-0.4,0-0.6h-0.4c-0.1,0-0.2-0.1-0.2-0.2v-0.6c0-0.1,0.1-0.2,0.2-0.2h0.5
                        c0.5-1.5,1.8-2.4,3.4-2.4c0.5,0,1,0.1,1,0.1s0.1,0,0.1,0.1v0.1l-0.2,0.8c0,0.1-0.1,0.1-0.2,0.1c0,0-0.4-0.1-0.7-0.1
                        c-0.9,0-1.6,0.5-2,1.3h2.5c0.1,0,0.1,0,0.1,0.1v0.1l-0.1,0.6c0,0.1-0.1,0.1-0.2,0.1h-2.6c0,0.2,0,0.3,0,0.6h2.4
                        c0.1,0,0.1,0,0.1,0.1v0.1l-0.1,0.6c0,0.1-0.1,0.1-0.2,0.1h-2c0.3,0.8,1.1,1.3,2,1.3c0.5,0,0.8-0.1,0.8-0.1h0.1l0.1,0.1
                        L234.1,187.1z"
					/>
				</g>
			</g>
			<path
				id="buildingSite_149_"
				class="building-site-35"
				d="M227.9,176.1c-3.3,1.4-5.7,4.6-5.9,8.4c0.2,3.2,2.1,6,4.7,7.6c4-2.9,5.4-8.3,3.3-12.9
                C229.5,178,228.8,177,227.9,176.1z"
			/>
			<g id="buildingSite_134_">
				<ellipse id="buildingSite_148_" class="building-site-13" cx="218.9" cy="182.9" rx="10.5" ry="10.5" />
				<g>
					<path
						class="building-site-3"
						d="M225,179v6.9c0,0.5-0.4,0.9-0.9,0.9H215c-0.5,0-0.9-0.4-0.9-0.9V179c0-0.5,0.4-0.9,0.9-0.9h9.1
                        C224.5,178.1,225,178.5,225,179z M214.7,179v1.3h9.5V179c0-0.1-0.1-0.2-0.2-0.2h-9.1C214.8,178.8,214.7,178.9,214.7,179z
                        M224.2,186v-3.5h-9.5v3.5c0,0.1,0.1,0.2,0.2,0.2h9.1C224.1,186.2,224.2,186.1,224.2,186z M215.5,184.7h1.5v0.7h-1.5V184.7z
                        M217.7,184.7h2.2v0.7h-2.2V184.7z"
					/>
				</g>
			</g>
			<path
				id="buildingSite_133_"
				class="building-site-35"
				d="M209.4,187.3c0.7,1.5,1.7,2.7,2.8,3.6c0.6-0.8,1.2-1.8,1.5-2.8c1.4-4.1,0.2-8.5-2.9-11.2
                c-1.5,1.8-2.4,4.1-2.4,6.5C208.5,184.7,208.8,186,209.4,187.3z"
			/>
			<g id="buildingSite_122_">
				<path
					id="buildingSite_132_"
					class="building-site-0"
					d="M211.7,186.4c-1.9,5.4-7.9,8.3-13.3,6.4c-5.4-1.9-8.3-7.9-6.4-13.3
                    c1.9-5.4,7.8-8.3,13.3-6.4C210.8,175.1,213.6,181,211.7,186.4z"
				/>
				<g>
					<path
						class="building-site-3"
						d="M202.2,186.6v0.9c0,0.1-0.1,0.2-0.2,0.2h-0.7c-0.1,0-0.2-0.1-0.2-0.2v-0.9c-1.2-0.2-1.9-0.9-2-1
                        s-0.1-0.2,0-0.2l0.6-0.7l0.1-0.1h0.1c0,0,0.8,0.7,1.7,0.7c0.5,0,1.1-0.3,1.1-0.9c0-0.5-0.6-0.8-1.4-1.1c-1-0.4-2.2-0.9-2.2-2.2
                        c0-1,0.8-1.8,1.9-2v-1c0-0.1,0.1-0.2,0.2-0.2h0.7c0.1,0,0.2,0.1,0.2,0.2v0.9c1.1,0.1,1.7,0.7,1.7,0.7c0.1,0.1,0.1,0.1,0,0.2
                        l-0.4,0.8l-0.1,0.1c-0.1,0-0.1,0-0.1,0s-0.7-0.6-1.5-0.6c-0.7,0-1.1,0.3-1.1,0.8c0,0.6,0.7,0.8,1.4,1.1c1,0.4,2.1,0.8,2.1,2.1
                        S203.3,186.4,202.2,186.6z"
					/>
				</g>
			</g>
		</g>
		<g id="buildingSite_33_">
			<g id="buildingSite_117_">
				<path
					id="buildingSite_120_"
					class="building-site-2 fill-primary"
					d="M183.5,183.9c0,5.1-4.1,9.3-9.3,9.3c-5.1,0-9.3-4.1-9.3-9.3s4.1-9.3,9.3-9.3
                    C179.3,174.6,183.5,178.8,183.5,183.9z"
				/>
				<g id="buildingSite_118_">
					<polygon id="buildingSite_119_" class="building-site-3" points="173.4,186.8 170.4,183.8 171.4,182.8 173.4,184.7 177,181 178.1,182.1 				" />
				</g>
			</g>
			<path
				id="buildingSite_116_"
				class="building-site-35"
				d="M165,183.9c0,2.9,1.4,5.6,3.5,7.2c1-0.8,1.9-1.9,2.5-3.1c1.9-4,0.8-8.6-2.4-11.4
                C166.3,178.4,165,181,165,183.9z"
			/>
			<g id="buildingSite_107_">
				<path
					id="buildingSite_115_"
					class="building-site-13"
					d="M169.2,188c-2.3,4.7-7.9,6.7-12.6,4.4c-4.7-2.3-6.7-7.9-4.4-12.6c2.3-4.7,7.9-6.7,12.6-4.4
                    C169.5,177.7,171.5,183.3,169.2,188z"
				/>
				<g id="buildingSite_108_">
					<g>
						<path
							id="buildingSite_110_"
							class="building-site-3"
							d="M160.2,182.7l1-2.1l1.7,0.8l-1,2.1l2.1,1l-0.7,1.5l-2.1-1l-1,2.1l-1.7-0.8l1-2.1l-2-1
                            l0.7-1.5L160.2,182.7z"
						/>
					</g>
				</g>
			</g>
			<path
				id="buildingSite_105_"
				class="building-site-35"
				d="M156,175.7c-1.6,0.9-3,2.3-3.9,4.1c-2.1,4.4-0.5,9.7,3.6,12.2c2.8-1.7,4.7-4.7,4.7-8.2
                C160.4,180.4,158.6,177.4,156,175.7z"
			/>
			<g id="buildingSite_34_">
				<circle id="buildingSite_103_" class="building-site-26" cx="149.4" cy="183.7" r="9.6" />
				<g>
					<path
						class="building-site-3"
						d="M152.9,183.9c0.2,0.3,0.3,0.7,0.3,1.2c-0.1,0.6-0.3,1.1-0.8,1.3c-0.4,0.2-1,0.4-1.7,0.4v1.2h-0.9v-1.2h-0.7
                        v1.2h-0.9v-1.2h-1.7l0.2-1h0.2c0.3,0,0.5,0,0.5,0c0.1,0,0.2-0.1,0.2-0.3v-3.8c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.3,0-0.7,0h-0.1
                        v-0.9h0.5c0.6,0,1,0,1.2,0v-1.4h0.9v1.4h0.7v-1.3h0.9v1.4c0.6,0.1,1,0.2,1.4,0.4s0.6,0.6,0.6,1c0.1,0.7-0.2,1.1-0.7,1.4
                        C152.3,183.4,152.7,183.6,152.9,183.9z M149.1,183.1h0.1c0.5,0,0.9,0,1.1-0.1c0.5-0.1,0.7-0.4,0.7-0.7c0-0.4-0.2-0.6-0.7-0.8
                        c-0.3-0.1-0.6-0.1-1.1-0.1c-0.1,0-0.1,0-0.2,0L149.1,183.1L149.1,183.1z M149.3,185.8c0.6,0,1,0,1.3-0.1
                        c0.5-0.1,0.8-0.4,0.8-0.8s-0.3-0.7-0.8-0.8c-0.3-0.1-0.7-0.1-1.3-0.1h-0.2v1.8L149.3,185.8L149.3,185.8z"
					/>
				</g>
			</g>
		</g>
		<g id="buildingSite_29_">
			<path
				id="buildingSite_30_"
				class="building-site-13"
				d="M125.9,185h2.3c0.5,0,0.9-0.4,0.9-0.9v-3c0-0.5-0.4-0.9-0.9-0.9h-1.8c-0.3,0-0.6-0.2-0.7-0.5
                c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.3-0.1-0.6,0.1-0.8l1.3-1.3c0.3-0.3,0.3-0.9,0-1.2l-2.1-2.1c-0.3-0.3-0.9-0.3-1.2,0l-1.3,1.3
                c-0.2,0.2-0.5,0.3-0.8,0.1c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3-0.1-0.4-0.4-0.4-0.7v-1.8c0-0.5-0.4-0.9-0.9-0.9h-3
                c-0.5,0-0.9,0.4-0.9,0.9v1.8c0,0.3-0.2,0.6-0.5,0.7c-0.2,0.1-0.4,0.1-0.5,0.2c-0.3,0.1-0.6,0.1-0.8-0.1l-1.3-1.3
                c-0.3-0.3-0.9-0.3-1.2,0l-2.1,2.1c-0.3,0.3-0.3,0.9,0,1.2l1.3,1.3c0.2,0.2,0.3,0.5,0.2,0.8c-0.1,0.2-0.2,0.4-0.2,0.6
                c-0.1,0.3-0.4,0.4-0.7,0.4h-1.8c-0.5,0-0.9,0.4-0.8,0.9v3c0,0.5,0.4,0.9,0.9,0.8h1.8c0.3,0,0.6,0.2,0.7,0.5
                c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.3,0.1,0.6-0.1,0.8l-1.3,1.3c-0.3,0.3-0.3,0.9,0,1.2l2.1,2.1c0.3,0.3,0.9,0.3,1.2,0l1.3-1.3
                c0.2-0.2,0.5-0.3,0.8-0.1c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0.1,0.4,0.4,0.4,0.7v1.8c0,0.5,0.4,0.9,0.9,0.8h3c0.5,0,0.9-0.4,0.8-0.9
                v-1.8c0-0.3,0.2-0.6,0.5-0.7c0.2-0.1,0.3-0.1,0.5-0.2c0.3-0.1,0.6-0.1,0.8,0.1l1.3,1.3c0.3,0.3,0.9,0.3,1.2,0l2.1-2.1
                c0.3-0.3,0.3-0.9,0-1.2l-1.3-1.3c-0.2-0.2-0.3-0.5-0.1-0.8C125.7,185.6,125.9,185,125.9,185z M114.1,181.9
                c0.5-2.6,3.2-4.1,5.6-3.2c1.9,0.7,3,2.7,2.6,4.7c-0.5,2.6-3.2,4.1-5.6,3.2C114.9,185.9,113.8,183.9,114.1,181.9z"
			/>
		</g>
		<g id="buildingSite_857_">
			<g id="buildingSite_868_">
				<path
					id="buildingSite_901_"
					class="building-site-36"
					d="M39.5,193H14.6c-1.2,0-2.2-1-2.2-2.2v-20.6h27.1c0.4,0,0.8,0.3,0.8,0.8v21.3
                    C40.2,192.6,39.9,193,39.5,193z"
				/>
				<path id="buildingSite_900_" class="building-site-37" d="M15.3,189.1c-1,0-3,0.2-3,2.3V169c0-1.3,1-2.3,2.3-2.3h0.7V189.1z" />
			</g>
			<path
				id="buildingSite_834_"
				class="building-site-2 fill-primary"
				d="M31.4,183.6h1.5c0.3,0,0.5-0.2,0.5-0.5v-1.9c0-0.3-0.2-0.5-0.5-0.5h-1.2
                c-0.2,0-0.4-0.1-0.4-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.1-0.4,0.1-0.5l0.8-0.8c0.2-0.2,0.2-0.6,0-0.8l-1.3-1.3
                c-0.2-0.2-0.6-0.2-0.8,0l-0.8,0.8c-0.1,0.1-0.3,0.2-0.5,0.1c-0.1-0.1-0.2-0.1-0.4-0.1c-0.2-0.1-0.3-0.2-0.3-0.4v-1.2
                c0-0.3-0.2-0.5-0.5-0.5h-1.9c-0.3,0-0.5,0.2-0.5,0.5v1.2c0,0.2-0.1,0.4-0.3,0.4c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.1-0.5-0.1
                l-0.9-0.9c-0.2-0.2-0.6-0.2-0.8,0l-1.3,1.3c-0.2,0.2-0.2,0.6,0,0.8l0.8,0.8c0.1,0.1,0.2,0.3,0.1,0.5c-0.1,0.1-0.1,0.2-0.1,0.4
                c-0.1,0.2-0.2,0.3-0.4,0.3h-1.2c-0.3,0-0.5,0.2-0.5,0.5v1.9c0,0.3,0.2,0.5,0.5,0.5h1.2c0.2,0,0.4,0.1,0.4,0.3
                c0,0.1,0.1,0.2,0.1,0.3c0.1,0.2,0.1,0.4-0.1,0.5l-0.8,0.8c-0.2,0.2-0.2,0.6,0,0.8l1.3,1.3c0.2,0.2,0.6,0.2,0.8,0l0.8-0.8
                c0.1-0.1,0.3-0.2,0.5-0.1c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0.1,0.3,0.2,0.3,0.4v1.2c0,0.3,0.2,0.5,0.5,0.5h1.9c0.3,0,0.5-0.2,0.5-0.5
                v-1.2c0-0.2,0.1-0.4,0.3-0.4c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.5,0.1l0.8,0.8c0.2,0.2,0.6,0.2,0.8,0l1.3-1.3
                c0.2-0.2,0.2-0.6,0-0.8l-0.8-0.8c-0.1-0.1-0.2-0.3-0.1-0.5C31.3,184,31.4,183.6,31.4,183.6z M23.9,181.6c0.3-1.7,2-2.6,3.6-2
                c1.2,0.5,1.9,1.7,1.7,3c-0.3,1.7-2,2.6-3.6,2C24.4,184.2,23.7,182.9,23.9,181.6z"
			/>
			<path
				id="buildingSite_858_"
				class="building-site-21"
				d="M40.2,192.4v-21.7c0-0.3-0.3-0.6-0.6-0.6h-1.8v19.1v0.6v2.5c0,0.3,0.3,0.6,0.6,0.6h1.2
                C40,193,40.2,192.7,40.2,192.4z"
			/>
			<g id="buildingSite_838_">
				<rect id="buildingSite_856_" x="38.6" y="168.3" class="building-site-13" width="2.5" height="21.6" />
				<path id="buildingSite_855_" class="building-site-37" d="M41.1,189.8h-2.5v2.3c0,0.5,0.4,0.8,0.8,0.8h0.9c0.5,0,0.8-0.4,0.8-0.8V189.8z" />
				<rect id="buildingSite_852_" x="38.6" y="168.3" class="building-site-38" width="1.3" height="21.6" />
				<path id="buildingSite_851_" class="building-site-24" d="M39.7,165.3l-1.2,2.9h2.6l-1.2-2.9C39.9,165.2,39.8,165.2,39.7,165.3z" />
				<path id="buildingSite_850_" class="building-site-22" d="M39.8,165.2l-0.3,0.8h0.7L39.8,165.2C39.8,165.1,39.8,165.1,39.8,165.2z" />
				<rect id="buildingSite_854_" x="38.6" y="189.2" class="building-site-22" width="2.5" height="0.6" />
			</g>
		</g>
	</g>
	<g>
		<path
			class="building-site-39"
			d="M339.4,182.9l-0.7,0.3l-0.4-0.8l1.1-0.3v-1.9l-9.4-22.7l-1.3-14.2c0,0,1.3-1.7,2.3-4.6
            c0.6-1.8,0.4-4.3,0.2-5.9h0.6v-2.4h-0.3c1.2-2.3,3.8-8.9,5.9-14.5c-0.1,0-0.1,0-0.2,0h-16.7l-0.7,0.7v-0.7h-31.7v9
            c0,1.2,0.9,2.1,2.1,2.1h0.8h8c-0.3,0.1-0.6,0.3-0.8,0.5l5.3,0.6h2.7l2.3-1.1h8.8c-0.5,1.5-1,2.7-1.3,3.4h-1v2.4h0.4l-1,5.1
            l-0.1,0.6l-5.8,18.9l-1.9,26.5h1.4v1.1h-1.3l-2.1,2.4h-4.5c-2.7,0-5.3,1.5-6.5,4h-0.7v1.5h19.5v-1.5h-0.7V185h-1v-1.1h1.5l4.4-28.1
            v-0.1l0,0l2.6-3.9l3.6,10.3l11.8,21.2l0.9-0.3l0.6,1.1l-0.8,0.4l-1,3l-5.1,0.1c-2.5,1-3.1,1.1-3.4,3.6h-0.4v1.5H336l0,0l3.4-1.4
            V182.9z"
		/>
		<g>
			<g id="buildingSite_49_">
				<g id="buildingSite_64_">
					<path
						id="buildingSite_67_"
						class="building-site-13"
						d="M318.1,107.9l-22.7,11.3c-0.4,0.2-0.8,0-1-0.3l-6.9-13.9c-0.2-0.4,0-0.8,0.3-1l22.7-11.3
                        c0.4-0.2,0.8,0,1,0.3l6.9,13.9C318.6,107.3,318.4,107.7,318.1,107.9z"
					/>
					<path
						id="buildingSite_66_"
						class="building-site-23"
						d="M318.4,107.3l-15.5-2.6c-0.4-0.1-0.8,0.1-0.9,0.5l-7.2,13.9c0.3,0.1,0.6,0.2,0.8,0
                        l22.3-11.1C318.2,107.9,318.3,107.6,318.4,107.3z"
					/>
					<path
						id="buildingSite_65_"
						class="building-site-23"
						d="M287.5,104.5l15.5,2.6c0.4,0.1,0.8-0.1,0.9-0.5l7.2-13.9c-0.3-0.1-0.6-0.2-0.8,0L288,103.8
                        C287.7,104,287.5,104.3,287.5,104.5z"
					/>
				</g>
				<path id="buildingSite_58_" class="building-site-35" d="M292.2,101.8c2.4,2.7,6.4,3.5,9.8,1.9c3.4-1.7,5.1-5.4,4.4-8.9L292.2,101.8z" />
				<g id="buildingSite_52_">
					<path
						id="buildingSite_57_"
						class="building-site-2 fill-primary"
						d="M305.4,91.8c2,4.1,0.4,9.1-3.7,11.1s-9.1,0.4-11.1-3.7s-0.4-9.1,3.7-11.1
                        S303.4,87.7,305.4,91.8z"
					/>
					<path
						id="buildingSite_56_"
						class="building-site-40"
						d="M302.5,93.3c1.2,2.5,0.2,5.5-2.3,6.8c-2.5,1.2-5.5,0.2-6.8-2.3c-1.2-2.5-0.2-5.5,2.3-6.8
                        C298.2,89.8,301.3,90.8,302.5,93.3z"
					/>
					<g id="buildingSite_53_">
						<polygon id="buildingSite_55_" class="building-site-3" points="300.5,97.7 299.3,98.3 296.9,93.5 295.8,94.1 295.2,92.9 297.5,91.7 					" />
					</g>
				</g>
			</g>
			<g id="buildingSite_43_">
				<path
					id="buildingSite_48_"
					class="building-site-3"
					d="M317.6,116.5l-17.9-10.8c-0.3-0.2-0.4-0.6-0.2-1l7.3-12.1c0.2-0.3,0.6-0.4,1-0.2l17.9,10.8
                    c0.3,0.2,0.4,0.6,0.2,1l-7.3,12.1C318.4,116.6,317.9,116.7,317.6,116.5z"
				/>
				<path id="buildingSite_47_" class="building-site-13" d="M315.5,109l-10.2-6.1c1.7-2.8,5.3-3.7,8.1-2C316.3,102.6,317.2,106.2,315.5,109z" />
				<polygon id="buildingSite_46_" class="building-site-37" points="305.5,106.6 314.4,104.5 316.3,113.2 			" />
				<polygon id="buildingSite_45_" class="building-site-41" points="300.9,103.9 309.9,101.7 311.8,110.4 			" />
				<path
					id="buildingSite_44_"
					class="building-site-41"
					d="M318,103.2l2,1.2c0.2,0.1,0.3,0.4,0.1,0.6l0,0c-0.1,0.2-0.4,0.3-0.6,0.1l-0.1-0.1
                    c-0.2-0.1-0.4-0.1-0.5,0.1l0,0c-0.1,0.2-0.1,0.4,0.1,0.5l2.1,1.3c0.2,0.1,0.2,0.3,0.1,0.5l0,0c-0.1,0.2-0.3,0.2-0.5,0.1l-6.6-4
                    c-0.2-0.1-0.2-0.3-0.1-0.5l0,0c0.1-0.2,0.3-0.2,0.5-0.1l0.4,0.3c0.2,0.1,0.4,0.1,0.5-0.1l0,0c0.1-0.2,0.1-0.4-0.1-0.5l-1.9-1.1
                    c-0.2-0.1-0.3-0.4-0.1-0.6l0,0c0.1-0.2,0.4-0.3,0.6-0.1L318,103.2z"
				/>
			</g>
			<g id="buildingSite_35_">
				<g id="buildingSite_36_">
					<path id="buildingSite_42_" class="building-site-34" d="M319.6,127h-26.5v-16.9h28.7v14.8C321.8,126.1,320.8,127,319.6,127z" />
					<path id="buildingSite_41_" class="building-site-42" d="M292.3,127h0.8v-16.9h-3v14.8C290.1,126.1,291.1,127,292.3,127z" />
					<polygon id="buildingSite_40_" class="building-site-33" points="290.1,113.7 292,113.7 293.1,110.1 290.1,110.8 				" />
					<path
						id="buildingSite_39_"
						class="building-site-34"
						d="M289.7,112.3h2.1c0.1,0,0.3-0.1,0.4-0.2l0.9-1.9h-3l-0.8,1.6
                        C289.2,112,289.4,112.3,289.7,112.3z"
					/>
					<polygon id="buildingSite_38_" class="building-site-33" points="321.8,113.7 321.8,110.8 293.1,110.1 294.6,113.7 				" />
					<path
						id="buildingSite_37_"
						class="building-site-34"
						d="M322.6,112.3h-27.7c-0.1,0-0.2-0.1-0.3-0.2l-1.5-2h28.7l1.1,1.5
                        C323.1,111.9,322.9,112.3,322.6,112.3z"
					/>
				</g>
			</g>
			<rect x="309.9" y="183.1" class="building-site-43" width="2.8" height="3.1" />

			<rect x="337.7" y="181.5" transform="matrix(0.8973 -0.4414 0.4414 0.8973 -45.9744 168.4781)" class="building-site-43" width="2.8" height="3.1" />
			<polygon
				class="building-site-11"
				points="332.9,131.3 328.3,141.3 318.6,155.9 314.2,184 308.5,184 310.4,157.5 316.2,138.6 317.7,131.3
                "
			/>
			<g class="building-site-29">
				<path class="building-site-26" d="M330.1,137.4l-13.2-2l-0.6,3.1l-0.7,2.2c1.5,3.8,3,9.2,3.1,15.1l9.6-14.5L330.1,137.4z" />
			</g>
			<rect x="332.7" y="93.8" class="building-site-43" width="5.8" height="6.8" />
			<polygon class="building-site-39" points="338.5,97.5 332.7,95.4 332.7,93.8 338.5,93.8 		" />
			<path
				class="building-site-44"
				d="M331.6,97.2l7.8,2v1.5c0,0,3.1,4.1,2.9,6.2s-8.2,23.6-9.4,24.4h-15.3c0,0,6.1-16,6.5-17.8
                c0,0,1.9-8.6,5.2-11.3c0,0,1-1.7,2-2.2C331.3,100.1,332.2,99,331.6,97.2z"
			/>
			<path class="building-site-45" d="M332.5,115.7l-4.6-5.9l4.2-3.6c1.4-1.5,3.8-1.5,5.3-0.1l0,0c1.5,1.4,1.5,3.8,0.1,5.3L332.5,115.7z" />
			<path class="building-site-44" d="M331.8,115l-4.5-5.9l4.9-3.8c1.5-1.2,3.7-0.9,4.9,0.7l0.3,0.3c1.2,1.5,0.9,3.7-0.7,4.9L331.8,115z" />
			<path class="building-site-26" d="M322.4,118.7c-0.7,1.8-1.4,3.8-2.1,5.7l3.4-1.6l8.8-7.1l-3.4-4.5L322.4,118.7z" />
			<path
				class="building-site-43"
				d="M308.2,128.1l14.4-6.8l8.8-7.1l-3.4-4.5l-7.2,8l-13,8.1l0.5,0.6l-2.6,0.1c-1.1,0-4.1-0.4-5.3,0.9l5.3,0.6
                L308.2,128.1L308.2,128.1z"
			/>
			<path
				class="building-site-11"
				d="M332.9,131.3c0,0,0.9,4.5,0,7.4s-2.3,4.6-2.3,4.6l1.3,14.2l10.1,24.3l-5.4,1.6l-11.8-21.2l-8.5-24.3l1.3-6.6
                H332.9z"
			/>
			<path class="building-site-46" d="M340.8,95.3h-8.4c-1.3,0-2.4-1.1-2.4-2.4v-2.7h-2.1C327,83.1,330,81,330,81h10.8V95.3z" />
			<g>
				<path
					class="building-site-47"
					d="M344,82.2c-0.2-1.2-1-3.2-2.1-3.8c-0.6-0.3-1.3-0.3-1.9,0c0-0.8-0.5-1.8-1.3-1.8c-0.5,0-1.1,0.2-1.6,0.3
                    c-1.8,0.6-3.6,1.2-5.5,1.1c-2,0-3.7-0.8-5-2.2c0,1.1,0.2,2.2,0.5,3.3c0.1,0.4,0.3,0.8,0.5,1.1c0.3,0.5,0.8,0.8,1.4,1.2
                    c1.5,1,2.6,0.4,4.2,0.5c0.7,0,1.3,0.2,2,0.2c0.6,0,1.4-0.2,2,0.1c1.9,1-2.5,3.6-2.5,4.5c1-0.5,2-1.1,2.9-1.6
                    c-1,1.2-2.1,2.5-2.1,4.1c0.7-0.7,1.6-1.2,2.6-1.4c-0.3,0.7-0.6,1.3-1,2c-0.1,0.2-0.2,0.5,0,0.6c0.3,0.2,0.7-0.4,1-0.2
                    c-0.4,0.9-0.8,1.8-1.2,2.8c0.4-0.2,0.8-0.4,1-0.7c-0.3,1-0.2,2.1,0.2,3c0.7-0.1,1.3,0.5,2.1,0.6c0.7,0.1,1.1-0.4,1.6-0.6
                    c0.7-0.3,1.7-0.3,2.4-0.1c-0.3-0.5-0.6-1-0.7-1.6c-0.4-1.5,0.4-2.6,0.6-4c0.2-1.7,0.2-3.4,0.2-5.1
                    C344.2,83.7,344.2,82.9,344,82.2z"
				/>
			</g>
			<rect x="317" y="130.5" class="building-site-45" width="16.8" height="2.4" />
			<path
				class="building-site-43"
				d="M307.4,127.3l-1.7-1.7c-0.3-0.2-0.4-0.5-0.3-0.8l0,0c0.2-0.3,0.5-0.4,0.8-0.3l2.3,1.2
                c0.3,0.2,0.4,0.5,0.3,0.8l0,0C308.6,126.8,307.7,127.4,307.4,127.3z"
			/>
			<path class="building-site-16" d="M313.7,185.1h-5.1l-2.1,2.4h-4.4c-2.7,0-5.3,1.5-6.5,4l0,0h18v-6.4H313.7z" />
			<path class="building-site-3" d="M312.7,188.3c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6S312.7,187.4,312.7,188.3z" />
			<rect x="294.9" y="191.5" class="building-site-13" width="19.5" height="1.5" />
			<path class="building-site-16" d="M342,182.7l-4.7,2l-1,3l-5.1,0.1c-2.5,1.1-3.2,1.1-3.4,3.8l0,0h9.4l7.2-3L342,182.7z" />
			<path
				class="building-site-3"
				d="M342.3,186c0.3,0.8,0,1.7-0.9,2.1c-0.8,0.3-1.7,0-2.1-0.9c-0.3-0.8,0-1.7,0.9-2.1
                C341,184.8,341.9,185.2,342.3,186z"
			/>
			<rect x="327.4" y="191.4" class="building-site-13" width="10.6" height="1.5" />

			<rect x="337.4" y="189.9" transform="matrix(0.9192 -0.3937 0.3937 0.9192 -47.4891 149.7885)" class="building-site-13" width="7.9" height="1.5" />
		</g>
	</g>
	<g>
		<path
			class="building-site-39"
			d="M154.4,66.9c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.4-0.1l0,0l0,0h-0.1h-0.1h-0.1c0-0.5,0-1-0.1-1.5h-0.1
            c0-0.1,0-0.3,0-0.4c-5.5,0-10.9-0.1-16.4-0.1c0,0.1,0,0.2,0,0.3h-0.1c-0.1,1.3-0.2,2.5,0,3.8h0.1c0,0.1,0,0.2,0,0.3
            c5.5,0,10.9,0.1,16.4,0.1l0,0c0-0.1,0-0.2,0-0.3c0.1,0,0.1,0,0.2,0c0.1-0.6,0.1-1.1,0.1-1.7h0.1h0.2l0,0l0,0c0,0,0,0,0,0.1v0.8v3.4
            v0.8v0.2v0.1l0,0l0,0c0,0.1-0.1,0.1-0.1,0.2l0,0l0,0l0,0l0,0l-0.2,0.1l-0.4,0.2l-0.8,0.4l-3,1.4l-3,1.4l-0.4,0.2
            c-0.1,0.1-0.2,0.1-0.3,0.2s-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3l0,0l0,0v0.1v0.1v0.4V79h-0.8v0.3c0,0.1,0,0.1,0.1,0.1h0.7h-0.7
            c-0.2,0-0.3,0.1-0.3,0.3l-0.1,1.2l0,0c-0.5,0.2-1.1,0.4-1.6,0.6s-1,0.4-1.3,0.9c-0.2,0.3-0.3,0.6-0.3,1c-0.1,0.7-0.1,1.4,0,2.2v0.6
            l-0.3-0.1l-12.6,8.7c0,0-7.3-3.8-10.9-5.3c-2.4-1-3.9-0.6-4.6-0.3l-0.6-3.2c0.8,0.1,1.7-0.1,2.6-0.1c0.7,0,1.4,0,1.9-0.4
            c0.7-0.5,1-1.3,1.2-2.1c0.2-0.5,0.3-1.1,0.5-1.6s0.3-1,0.3-1.6c0-0.5-0.2-1-0.6-1.3c0.2,0,0.5,0,0.7,0s0.4-0.2,0.3-0.4
            c-0.2-1-0.5-2-0.7-3c-0.2-1.1,0-2.2-0.7-3.2c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.4,0.4-0.8,0.3-1.2c-0.1-0.5-0.5-1-0.9-1.2
            c-1.2-0.6-2.1-0.4-3.3,0c-0.5,0.2-1.2,0.2-1.6-0.2c-0.2-0.1-0.3-0.3-0.4-0.5c-0.7-0.9-2.2-1-3-0.2s-1.1,1.4-2.2,1.8
            c-0.7,0.2-1.5,0.5-2,1.1v2.1c0.1,0.2,0.2,0.4,0.2,0.7c0.1,0.3-0.1,0.6-0.2,0.8v4.5c0.6,0.6,0.5,1.4,0.5,2.3c0,0.5-0.3,0.8-0.5,1.2
            v1.5c0.4,0.5,1.2,0.5,1.8,0.2v0.3c0,0.2,0.2,0.4,0.4,0.4h0.4l-0.6,4.3h-0.9l-1.2,0.4v87h1.6h0.6v-1.4h-0.6v-0.4l-0.6-2.2h-0.4v-0.3
            h0.8l1.5-26.3l6.3-17.2l9.4,10.7l-7.3,22.3l0.9,0.1l-0.3,0.6h-0.5l-1.3,1.6v1.3h-0.5v1h0.5h14h0.4v-1h-0.3v-0.1
            c0-0.9-0.6-1.7-1.5-1.8l-4.7-1h-3.3l0.2-0.4l0.9,0.1l11.8-24.6l-11.6-20l-0.6-1l1.4-17.5l9.7,1.3c0.5,0.1,1-0.1,1.4-0.5
            c0.1-0.1,0.2-0.3,0.3-0.4L143.8,88v0.3c0,0.2,0.1,0.3,0.3,0.3h2.6c0.2,0,0.3-0.1,0.3-0.3l-0.1-1.7c0.4-0.2,0.7-0.5,0.9-1
            c0.2-0.6,0-0.7-0.1-1.2c-0.1-0.4,0.1-0.7-0.3-0.9c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.2c0.3-0.3,0.2-0.9-0.1-1.1
            c-0.1-0.1-0.3-0.2-0.5-0.3l-0.1-2c0-0.2-0.2-0.3-0.3-0.3h-0.5h0.6c0.1,0,0.1,0,0.1-0.1v-0.3h-0.7v-1.3v-0.4v-0.2v-0.1
            c0-0.1,0.1-0.1,0.1-0.2l0.4-0.2l3-1.4l3-1.4l0.8-0.4l0.4-0.2l0.2-0.1l0,0l0,0l0,0c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.3-0.3,0.3-0.5
            c0-0.1,0-0.1,0-0.2v-0.1v-0.1V72v-0.8v-3.4V67v-0.1C154.4,67,154.4,66.9,154.4,66.9z M143.8,87.6l-0.2-0.1c0.1,0,0.1,0,0.2-0.1
            V87.6z"
		/>
		<g>
			<g>
				<path
					class="building-site-3"
					d="M152.4,67.1c0-0.1,0-0.1,0-0.2s-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.4-0.1l0,0l0,0h-0.1h-0.1h-1.7v0.1v0.1
                    v0.1v0.1V67h1.7h0.2l0,0l0,0c0,0,0,0,0,0.1v0.8v3.4v0.8v0.2v0.1l0,0l0,0c0,0.1-0.1,0.1-0.1,0.2l0,0l0,0l0,0l0,0l-0.2,0.1
                    l-0.4,0.2l-0.8,0.4l-3,1.4l-3,1.4l-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2s-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3l0,0l0,0v0.1v0.1
                    v0.4v1.7h0.1h0.1h0.1h0.1h0.1v-1.7v-0.4v-0.2V77c0-0.1,0.1-0.1,0.1-0.2l0.4-0.2l3-1.4l3-1.4l0.8-0.4l0.4-0.2l0.2-0.1l0,0l0,0l0,0
                    c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.1,0-0.2v-0.1v-0.1v-0.2v-0.8v-3.4v-0.8
                    C152.4,67.2,152.4,67.1,152.4,67.1z"
				/>
				<path class="building-site-13" d="M151.3,68.8c-0.1,0-0.2,0-0.3,0c0-1.3,0-2.5,0-3.8c0.1,0,0.2,0,0.3,0C151.5,66.2,151.5,67.5,151.3,68.8z" />
				<path class="building-site-13" d="M134.6,68.6c0.1,0,0.2,0,0.3,0c0-1.3,0-2.5,0-3.8c-0.1,0-0.2,0-0.3,0C134.5,66,134.5,67.3,134.6,68.6z" />
				<path
					class="building-site-48"
					d="M151.2,64.6c0.1,1.5,0.1,3,0,4.5c-5.5,0-10.9-0.1-16.4-0.1c-0.1-1.5-0.1-3,0-4.5
                    C140.2,64.5,145.7,64.5,151.2,64.6z"
				/>
				<path
					class="building-site-2 fill-primary"
					d="M134.7,66.7c0,0.7,0,1.5,0.1,2.2c5.5,0,10.9,0.1,16.4,0.1c0.1-0.7,0.1-1.5,0.1-2.2
                    C145.7,66.8,140.2,66.7,134.7,66.7z"
				/>
				<path
					class="building-site-13"
					d="M141.7,88.3c0,0.2,0.1,0.3,0.3,0.3h2.6c0.2,0,0.3-0.1,0.3-0.3l-0.3-8.5c0-0.2-0.2-0.3-0.3-0.3h-1.9
                    c-0.2,0-0.3,0.1-0.3,0.3L141.7,88.3z"
				/>
				<path class="building-site-49" d="M144.5,79.1v0.3c0,0.1,0,0.1-0.1,0.1h-2c-0.1,0-0.1,0-0.1-0.1v-0.3H144.5z" />
				<path class="building-site-50" d="M143.5,79.5h-1c-0.2,0-0.3,0.1-0.3,0.3l-0.4,8.5c0,0.2,0.1,0.3,0.3,0.3h1.3L143.5,79.5z" />
			</g>
			<path
				class="building-site-51"
				d="M145.2,82.1c-0.8-0.8-2.2,0.2-3,0.5c0.5-0.2,0.7-1.1,0.3-1.5c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0
                c-0.5,0.2-1.1,0.4-1.6,0.6s-1,0.4-1.3,0.9c-0.2,0.3-0.3,0.6-0.3,1c-0.1,0.7-0.1,1.4,0,2.2v0.8c0.5,0.6,1.3,0.6,2,1
                c0.2,0.1,0.4,0.2,0.6,0.1c0.2,0,0.4-0.1,0.6-0.2c0.7-0.3,1.5-0.6,2.3-0.6c0.7,0,1.3-0.4,1.5-1.1c0.2-0.6,0-0.7-0.1-1.2
                c-0.1-0.4,0.1-0.7-0.3-0.9c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.2C145.6,82.9,145.5,82.4,145.2,82.1z"
			/>
			<rect x="101" y="170.8" class="building-site-51" width="2.5" height="3.6" />

			<rect x="114.4" y="161.2" transform="matrix(0.434 -0.9009 0.9009 0.434 -80.5301 196.66)" class="building-site-51" width="3.6" height="2.5" />
			<path
				class="building-site-51"
				d="M100.5,68.9c0-0.2,0-0.4-0.1-0.6c-0.2-0.3-0.5-0.4-0.8-0.4s-0.6,0-0.9-0.1s-0.5-0.3-0.8-0.3
                c-0.7-0.1-1.3,0.9-2,0.7c-0.2,0-0.3-0.1-0.5-0.2c-0.6-0.2-1.2,0.3-1.3,0.9c-0.2,0.6,0,1.2,0.1,1.8c0.2,0.8,0.9,2.2,1.4,2.9
                c1.3,0,1.6,0.4,2.9,0.5c0,0,0.6-1,0.5-1h0.1c0.1-0.3,0.5-0.6,0.7-0.9c0.3-0.3,0.6-0.7,0.8-1.1c0.1-0.3,0.1-0.7,0.1-1.1
                C100.5,69.7,100.5,69.3,100.5,68.9z"
			/>
			<polygon class="building-site-51" points="110.6,90.2 104.8,90.2 105.8,82.6 109.1,82.6 		" />
			<polygon
				class="building-site-44"
				points="102.8,115.1 98,145.2 100.4,172.8 104.3,172.8 105.9,146.5 112.2,129.3 121.6,140 114.2,162.3
                118.7,162.5 130.5,137.9 117.2,115.1 		"
			/>
			<g>
				<polygon class="building-site-52" points="104.8,115.1 102.8,115.1 98,145.2 100.4,172.8 100.9,172.8 100,145.2 			" />
			</g>
			<g>
				<polygon class="building-site-45" points="122,139.6 113.7,127.8 112.2,129.3 121.6,140 			" />
			</g>
			<polygon class="building-site-39" points="109.1,82.6 105.8,82.6 105.2,87.2 109.7,85.7 		" />
			<path
				class="building-site-46"
				d="M112,85.4h-6.9c-0.2,0-0.4-0.2-0.4-0.4V70.6h6.9c0.9,0,1.7,0.2,2.5,0.6c2.3,1.2,1.8,2.8,2,4.3
                c0.2,1,0.5,2,0.7,3c0,0.2-0.1,0.4-0.3,0.4c-0.6,0-1.6,0.1-1.6,0.1l0.4,2.5C115.6,83.5,114,85.4,112,85.4z"
			/>
			<g>
				<path
					class="building-site-53"
					d="M115.7,78.9c-1.7-1-2.7,1.1-3.9,1.7c-0.6,0.2-1.4,0.2-1.7-0.4c-0.5-0.7-0.9-2.1-0.8-2.9s0.2-1.6,0.5-2.3
                    c0.4-0.7,1-1.5,1.8-1.9c0.4-0.2,0.8-0.3,1.2-0.2c0.6,0.1,0.9,0.3,1.5,0.1c0.6-0.2,1.2-0.8,1.6-1.4c0.2-0.4,0.4-0.8,0.3-1.2
                    c-0.1-0.5-0.5-1-0.9-1.2c-1.2-0.6-2.1-0.4-3.3,0c-0.5,0.2-1.2,0.2-1.6-0.2c-0.2-0.1-0.3-0.3-0.4-0.5c-0.7-0.9-2.2-1-3-0.2
                    s-1.1,1.4-2.2,1.8c-0.7,0.2-1.6,0.6-2.1,1.2c-0.7,1.1,0.2,1.7,0.3,2.7c0.1,0.5-0.3,0.9-0.5,1.3c-0.5,0.8-0.7,1.8-0.5,2.7
                    c0.1,0.4,0.3,0.9,0.6,1.1c0.8,0.6,0.7,1.5,0.7,2.5c0,0.8-0.7,1.2-0.7,1.9c-0.1,1.5,2.2,1.5,2.7,0.3c0.6-1.6,0.1-3.4,0.1-5
                    c0-0.9,1-2.1,2-1.4c0.6,0.4,0.5,1,0.5,1.6c0,0.9-0.1,1.8-0.1,2.7c-0.1,1.3-0.6,3.1,0.8,4c1.3,0.7,2.4,0.3,3.8,0.3
                    c0.7,0,1.4,0,1.9-0.4c0.7-0.5,1-1.3,1.2-2.1c0.2-0.5,0.3-1.1,0.5-1.6s0.3-1,0.3-1.6C116.3,79.7,116.1,79.2,115.7,78.9z"
				/>
			</g>
			<path
				class="building-site-39"
				d="M102.8,115.1L102,120c1.4,0,3.3,0.3,4.6-0.2c1.5-0.6,2.8-1.9,4.5-1.8c0.8,0.1,1.5,0.4,2.2,0.6
                c1,0.3,2.1,0.3,3.1,0.1c0.9-0.2,1.6-0.7,2.5-0.9l-1.6-2.7H102.8L102.8,115.1z"
			/>
			<path
				class="building-site-11"
				d="M109.9,89.6c0,0,1.5-1.5,5.1,0c3.5,1.5,10.9,5.3,10.9,5.3l12.6-8.7l3.6,1.6l-11,12.1c-0.3,0.6-1,1-1.7,0.9
                l-9.7-1.3l-1.4,17.5c-0.9,0.1-1.6,0.7-2.5,0.9c-1,0.2-2,0.2-3-0.1c-0.7-0.2-1.4-0.6-2.1-0.6c-1.6-0.1-2.8,1.1-4.3,1.7
                c-1.4,0.6-3.8,0.1-5.2,0.3c-0.4-1.8,1.2-4,1-5.9c-0.3-2.9-0.9-6-2.6-8.4l-8.9-17.2L95,73.8h4.1l-2.3,11.6l3.3,5.8l4.1-1.5
                L109.9,89.6L109.9,89.6z"
			/>
			<polygon class="building-site-54" points="127.3,94.9 138.9,86.4 138.4,86.1 125.9,94.9 		" />
			<path class="building-site-54" d="M103,119c0.7,0,1.4,0.1,2,0C104.3,119,103.6,119,103,119z" />
			<path
				class="building-site-54"
				d="M103.6,113.2c-0.3-2.9-0.9-6-2.6-8.4l-8.9-17.2l3.3-13.9h-0.5l-4.3,13.9l8.9,17.2c1.7,2.4,2.3,5.5,2.6,8.4
                c0.2,1.9-1.4,4.1-1,5.9c0.4-0.1,0.9-0.1,1.5,0C102.3,117.2,103.8,115,103.6,113.2z"
			/>
			<g>
				<path
					class="building-site-55"
					d="M127.8,99.3l-9.7-1.3c0,0-0.8,19.1,0.1,18.9l1.4-17.5l9.7,1.3c0.7,0.1,1.4-0.3,1.7-0.9
                    C131,99.9,128.5,99.4,127.8,99.3z"
				/>
			</g>
			<polygon class="building-site-11" points="104.5,177.1 100,177.1 100,175.1 100.6,173.1 103.9,173.1 104.5,175.3 		" />
			<rect x="99.4" y="175.7" class="building-site-16" width="5.7" height="1.4" />
			<path class="building-site-11" d="M127.1,166.8h-14v-2.3l1.3-1.6h6.5l4.7,1c0.9,0.2,1.5,1,1.5,1.8V166.8z" />
			<rect x="112.6" y="165.8" class="building-site-16" width="14.9" height="1" />
		</g>
	</g>
</svg>
